/**
 * Form data for Kubernetes Registry Policy
 * Represents which namespaces each registry is accessible in
 */
export interface KubernetesRegistryFormData {
  accessRows: Array<{
    registryId: number;
    namespaces: string[];
  }>;
}

/**
 * API payload for Kubernetes Registry Policy
 * Namespaces only per registry (access is at namespace level, not user/team level)
 */
export interface KubernetesRegistryPolicyPayload {
  RegistryAccessPolicies: Record<
    string,
    {
      Namespaces: Array<{ value: string; enforce: boolean }>;
    }
  >;
}

/**
 * Default initial values for Kubernetes Registry Policy (create mode)
 */
export const KUBERNETES_REGISTRY_INITIAL_VALUES: KubernetesRegistryFormData = {
  accessRows: [],
};
